import React, { useState } from "react";
import Styles from "./Index.module.css";
import HeaderPage from "../../header/Header";
import InvestorsImage from "../../../../assets/images/InvestorsImage.png";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import cloneDeep from "lodash/cloneDeep";
import throttle from "lodash/throttle";
import Pagination from "rc-pagination";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import PartiesImage from "../../../../assets/images/PartiesImage.png";
import NotesImage from "../../../../assets/images/NotesImage.png";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import Modal from "@mui/material/Modal";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export const InputStyled = styled(TextField)`
  & .MuiOutlinedInput-root {
    border-color: rgb(166, 167, 172);
    color: rgb(13, 13, 14);
    height: 46px;
    font-size: 14px;

    & fieldset {
      border-color: rgb(166, 167, 172);
    }

    &:hover fieldset {
      border-color: rgb(166, 167, 172);
    }

    &.Mui-focused fieldset {
      border-color: rgb(166, 167, 172);
      border: 1px solid rgb(166, 167, 172);
    }

    &.Mui-active fieldset {
      border-color: rgb(166, 167, 172);
    }
  }
`;

const CoProducersDetails = () => {
  const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [openEdit, setOpenEdit] = useState(false);
    const handleOpenEdit = () => setOpenEdit(true);
    const handleCloseEdit = () => setOpenEdit(false);

    const [createCoProducers, setCreateCoProducers] = useState({
        firstname: "",
        lastname: "",
        emailid: "",
        addtess: "",
        mobilenumber: "",
        city: "",
        state: "",
        zipcode: "",
        county: "",
        accredited: "",
        date_added: "",
        general_comments: "",
        CoProducers_probability: "",
        CoProducers_projects: "",
        projectname: "",
        status: "",
        final_amount: "",
        invesment_method: "",
      });
    
      console.log(createCoProducers, "createCoProducers");
    
      const addNewCoProducers = () => {
        handleClose();
      };
    
  const theme = useTheme();
  // let dispatch = useDispatch();

  // tab start
  const [searchValue, setSearchValue] = useState("");

  const [value, setValue] = useState(0);

  const [partiesAndNotesOpen, setPartiesAndNotesOpen] = useState(false);
  const [notesOpen, setnotesOpen] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const HandleCahngePatiesAndNotes = () => {
    if (partiesAndNotesOpen === false) {
      setPartiesAndNotesOpen(true);
    } else {
      setPartiesAndNotesOpen(false);
    }
  };

  const HandleCahngeNotes = () => {
    if (notesOpen === false) {
      setnotesOpen(true);
    } else {
      setnotesOpen(false);
    }
  };


    //   tableData Start
    const allData = [
      {
        no: "33",
      projectName: "ABC Project",
      viewInvestor: "View ",
      status: "Actively Rasi...",
      startDate:"02/19/2025",
      totalRaised:"$45,000",
      action: (
        <div className={Styles.CoProducersDetailsTableActionContainer}>
          <EditOutlinedIcon className={Styles.CoProducersDetailsTableActionEditIcon} />
          <RemoveRedEyeOutlinedIcon
            className={Styles.CoProducersDetailsTableActionViewIcon}
          />
          <DeleteOutlineOutlinedIcon
            className={Styles.CoProducersDetailsTableActionDeleteIcon}
          />
        </div>
      ),
    
    },
        {
            no: "33",
          projectName: "ABC Project",
          viewInvestor: "View ",
          status: "Actively Rasi...",
          startDate:"02/19/2025",
          totalRaised:"$45,000",
          action: (
            <div className={Styles.CoProducersDetailsTableActionContainer}>
              <EditOutlinedIcon className={Styles.CoProducersDetailsTableActionEditIcon} />
              <RemoveRedEyeOutlinedIcon
                className={Styles.CoProducersDetailsTableActionViewIcon}
              />
              <DeleteOutlineOutlinedIcon
                className={Styles.CoProducersDetailsTableActionDeleteIcon}
              />
            </div>
          ),
        
        },
        {
          no: "33",
        projectName: "ABC Project",
        viewInvestor: "View ",
        status: "Actively Rasi...",
        startDate:"02/19/2025",
        totalRaised:"$45,000",
        action: (
          <div className={Styles.CoProducersDetailsTableActionContainer}>
            <EditOutlinedIcon className={Styles.CoProducersDetailsTableActionEditIcon} />
            <RemoveRedEyeOutlinedIcon
              className={Styles.CoProducersDetailsTableActionViewIcon}
            />
            <DeleteOutlineOutlinedIcon
              className={Styles.CoProducersDetailsTableActionDeleteIcon}
            />
          </div>
        ),
      
      },
     
      ];
    
      const tableHead = {
        no: "No",
        projectName: "Project Name",
        viewInvestor: "View Investor",
        status: "Status",
        startDate:"Start Date",
        totalRaised:"Total Raised",
        action: "Actions",
      };
      const countPerPage = 5;
      const [currentPage, setCurrentPage] = useState(1);
      const [collection, setCollection] = useState(
        cloneDeep(allData.slice(0, countPerPage))
      );
    
    
      const updatePage = (p) => {
        setCurrentPage(p);
        const to = countPerPage * p;
        const from = to - countPerPage;
        setCollection(cloneDeep(allData.slice(from, to)));
      };
    
      const tableRows = (rowData) => {
        const { key, index } = rowData;
        const tableCell = Object.keys(tableHead);
        const columnData = tableCell.map((keyD, i) => {
          return <td key={i}>{key[keyD]}</td>;
        });
    
        return <tr key={index}>{columnData}</tr>;
      };
    
      const tableData = () => {
        return collection.map((key, index) => tableRows({ key, index }));
      };
    
      const headRow = () => {
        return Object.values(tableHead).map((title, index) => (
          <td key={index}>{title}</td>
        ));
      };
    
      //   table data end

  return (
    <div className={Styles.CoProducersDetailsMainConatiner}>
      <HeaderPage />
      <div className={Styles.CoProducersDetailsContainer}>
        <div className={Styles.CoProducersDetailsNavConatiner}>
          <div className={Styles.CoProducersDetailsNavImageConatiner}>
            <img
              src={InvestorsImage}
              alt="InvestorsImage"
              className={Styles.CoProducersDetailsNavConatinerImg}
            />
            <p className={Styles.CoProducersDetailsNavImageConatinerText}>
              Co-Producers
            </p>
          </div>
          <CalendarMonthOutlinedIcon
            className={Styles.CoProducersDetailsNavConatinerIcon}
          />
        </div>
        <div className={Styles.CoProducersDetailsTitleConatiner}>
          <p className={Styles.CoProducersDetailsTitleConatinerText}>Christin Stew</p>
          <button className={Styles.CoProducersDetailsTitleConatinerButton} onClick={handleOpen}>
            Add Co-Producers
          </button>
        </div>
        <div className={Styles.CoProducersDetailsTabsAndNotesContainer}>
          <div className={Styles.CoProducersDetailsTabs}>
            <div className={Styles.CoProducersDetailsTabsContainer}>
              <Box sx={{ bgcolor: "background.paper" }}>
                <AppBar
                  position="static"
                  sx={{ bgcolor: "#fff", borderRadius: "10px", boxShadow: "none" }}
                >
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                    TabIndicatorProps={{
                      sx: {
                        backgroundColor: "#2f8cff",
                        height: "2px",
                        borderRadius: "2px",
                      },
                    }}
                  >
                    <Tab
                      label={<p className={Styles.TabAddIconTExt}>Details</p>}
                      {...a11yProps(0)}
                      sx={{ maxWidth: "15% !important" }}
                    />
                    <Tab
                      label={<p className={Styles.TabAddIconTExt}>Projects</p>}
                      {...a11yProps(1)}
                      sx={{ maxWidth: "15% !important" }}
                    />
                  </Tabs>
                </AppBar>
                <TabPanel value={value} index={0} dir={theme.direction}>
                  <div className={Styles.CoProducersDetailsTabDetailsContainer}>
                    <div className={Styles.CoProducersDetailsTabDetailsHeader}>
                      <p className={Styles.CoProducersDetailsTabDetailsHeaderText}>
                       Co-Producers Info
                      </p>
                      <EditOutlinedIcon
                        className={
                          Styles.CoProducersDetailsTabDetailsHeaderEditIcon 
                        }
                        onClick={handleOpenEdit}/>
                    </div>
                    <div className={Styles.CoProducersDetailsInformationContianer}>
                      <div className={Styles.CoProducersDetailsInformationContent}>
                        <div className={ Styles.CoProducersDetailsInformationDetailsCard}   >
                          <p   className={  Styles.CoProducersDetailsInformationDetailsCardText }  >Co-Producer Name</p>
                          <p  className={  Styles.CoProducersDetailsInformationDetailsCardTextdata}  >Christin Stew </p>
                        </div>
                        <div className={Styles.CoProducersDetailsInformationDetailsCard} >
                          <p className={Styles.CoProducersDetailsInformationDetailsCardText}> Email </p>
                          <p className={Styles.CoProducersDetailsInformationDetailsCardTextdata}>stew@gmail.com </p>
                        </div>
                      </div>

                      <div className={Styles.CoProducersDetailsInformationContent}>
                        <div className={ Styles.CoProducersDetailsInformationDetailsCard}   >
                          <p   className={  Styles.CoProducersDetailsInformationDetailsCardText }  > Phone</p>
                          <p  className={  Styles.CoProducersDetailsInformationDetailsCardTextdata}  >205 555-4567</p>
                        </div>
                        <div className={Styles.CoProducersDetailsInformationDetailsCard} >
                          <p className={Styles.CoProducersDetailsInformationDetailsCardText}> Legal Entity  </p>
                          <p className={Styles.CoProducersDetailsInformationDetailsCardTextdata}>Lorem ipsum dolor sit amet, consectetuer ut</p>
                        </div>
                      </div>
                      <div className={Styles.CoProducersDetailsInformationContent}>
                        <div className={ Styles.CoProducersDetailsInformationDetailsCard}   >
                          <p   className={  Styles.CoProducersDetailsInformationDetailsCardText }  >Street Address</p>
                          <p  className={  Styles.CoProducersDetailsInformationDetailsCardTextdata}  >Lorem ipsum dolor sit amet, consectetuer ut</p>
                        </div>
                        <div className={Styles.CoProducersDetailsInformationDetailsCard} >
                          <p className={Styles.CoProducersDetailsInformationDetailsCardText}> City </p>
                          <p className={Styles.CoProducersDetailsInformationDetailsCardTextdata}>Argo</p>
                        </div>
                      </div>
                      <div className={Styles.CoProducersDetailsInformationContent}>
                        <div className={ Styles.CoProducersDetailsInformationDetailsCard}   >
                          <p   className={  Styles.CoProducersDetailsInformationDetailsCardText }  > State</p>
                          <p  className={  Styles.CoProducersDetailsInformationDetailsCardTextdata}  >Alabama</p>
                        </div>
                        <div className={Styles.CoProducersDetailsInformationDetailsCard} >
                          <p className={Styles.CoProducersDetailsInformationDetailsCardText}> Zip Code </p>
                          <p className={Styles.CoProducersDetailsInformationDetailsCardTextdata}>35004</p>
                        </div>
                      </div>
                      <div className={Styles.CoProducersDetailsInformationContent}>
                        <div className={ Styles.CoProducersDetailsInformationDetailsCard}   >
                          <p   className={  Styles.CoProducersDetailsInformationDetailsCardText }  > Totla Allocation</p>
                          <p  className={  Styles.CoProducersDetailsInformationDetailsCardTextdata}  >$25,000.00</p>
                        </div>
                        <div className={Styles.CoProducersDetailsInformationDetailsCard} >
                          <p className={Styles.CoProducersDetailsInformationDetailsCardText}>Status</p>
                          <p className={Styles.CoProducersDetailsInformationDetailsCardTextdata}>Still Raising</p>
                        </div>
                      </div>
                      <div className={Styles.CoProducersDetailsInformationContent}>
                        <div className={ Styles.CoProducersDetailsInformationDetailsCard}   >
                          <p   className={  Styles.CoProducersDetailsInformationDetailsCardText }  > Total Raised</p>
                          <p  className={  Styles.CoProducersDetailsInformationDetailsCardTextdata}  >$25,000.00</p>
                        </div>
                        <div className={Styles.CoProducersDetailsInformationDetailsCard} >
                          <p className={Styles.CoProducersDetailsInformationDetailsCardText}>Entitlememnt</p>
                          <p className={Styles.CoProducersDetailsInformationDetailsCardTextdata}>$26,000.00</p>
                        </div>
                      </div>
                      <div className={Styles.CoProducersDetailsInformationContent}>
                        <div className={Styles.CoProducersDetailsInformationDetailsCard} >
                          <p className={Styles.CoProducersDetailsInformationDetailsCardText}>General Comments</p>
                          <p className={Styles.CoProducersDetailsInformationDetailsCardTextdata}>Lorem ipsum dolor sit amet, consectetuer ut</p>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                <div>
                <div className={Styles.CoProducersDetailsPageInvestorTableHeaderButtonContainer}>
                        <button className={Styles.CoProducersDetailsPageInvestorTableHeaderButton} >Add New</button>
                </div>
                <div className={Styles.CoProducersDetailsPageInvestorTabsContainerTable}>
                  <table>
                    <thead>
                      <tr>{headRow()}</tr>
                    </thead>
                    <tbody className="trhover">{tableData()}</tbody>
                  </table>
                  <div className={Styles.CoProducersDetailsPageInvesotrTablePagination}>
                    <Pagination
                      pageSize={countPerPage}
                      onChange={updatePage}
                      current={currentPage}
                      total={allData.length}
                    />
                  </div>
                </div>
              </div>
                </TabPanel>
              </Box>
            </div>
          </div>

          <div className={Styles.CoProducersDetailsPartiesAndNotesContainer}>
            <div
              className={
                Styles.CoProducersDetailsPartiesAndNotesContentMainContainer
              }
            >
              <div className={Styles.CoProducersDetailsPartiesAndNotesContent}>
                <div
                  className={Styles.CoProducersDetailsPartiesAndNotesContentHeader}
                >
                  <img src={PartiesImage} alt="PartiesImage" />
                  <p
                    className={
                      Styles.CoProducersDetailsPartiesAndNotesContentHeaderText
                    }
                  >
                    Party's Project
                  </p>
                </div>
                <ExpandMoreOutlinedIcon
                  className={Styles.CoProducersDetailsPAtiesAndNotesIcon}
                  onClick={() => HandleCahngePatiesAndNotes()}
                />
              </div>
              {partiesAndNotesOpen === true ? (
                <div className={Styles.CoProducersDetailsPartiesContainer}>
                  <p className={Styles.CoProducersDetailsPartiesContainerText}>
                    ABC Project 
                  </p>
                  <div className={Styles.CoProducersDetailsPartiesContent}>
                    <p className={Styles.CoProducersDetailsPartiesContentTitle}>
                      Status
                    </p>
                    <p className={Styles.CoProducersDetailsPartiesContentText}>
                      Investing In Deal
                    </p>
                  </div>
                  <div className={Styles.CoProducersDetailsPartiesContent}>
                    <p className={Styles.CoProducersDetailsPartiesContentTitle}>
                      Final Amount
                    </p>
                    <p className={Styles.CoProducersDetailsPartiesContentText}>
                      $50,974
                    </p>
                  </div>
                  <div className={Styles.CoProducersDetailsPartiesContent}>
                    <p className={Styles.CoProducersDetailsPartiesContentTitle}>
                      Invesment Method
                    </p>
                    <p className={Styles.CoProducersDetailsPartiesContentText}>
                      SVP
                    </p>
                  </div>
                  <p className={Styles.CoProducersDetailsPartiesContainerText}>
                    ABC Project 
                  </p>
                  <div className={Styles.CoProducersDetailsPartiesContent}>
                    <p className={Styles.CoProducersDetailsPartiesContentTitle}>
                      XXX Project
                    </p>
                    <p className={Styles.CoProducersDetailsPartiesContentText}>
                      Investing In Deal
                    </p>
                  </div>
                  <div className={Styles.CoProducersDetailsPartiesContent}>
                    <p className={Styles.CoProducersDetailsPartiesContentTitle}>
                      Final Amount
                    </p>
                    <p className={Styles.CoProducersDetailsPartiesContentText}>
                      $25,000,00
                    </p>
                  </div>
                  <div className={Styles.CoProducersDetailsPartiesContent}>
                    <p className={Styles.CoProducersDetailsPartiesContentTitle}>
                      Invesment Method
                    </p>
                    <p className={Styles.CoProducersDetailsPartiesContentText}>
                      Direct To Production
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div
              className={
                Styles.CoProducersDetailsPartiesAndNotesContentMainContainer
              }
            >
              <div className={Styles.CoProducersDetailsPartiesAndNotesContent}>
                <div
                  className={Styles.CoProducersDetailsPartiesAndNotesContentHeader}
                >
                  <img src={NotesImage} alt="NotesImage" />
                  <p
                    className={
                      Styles.CoProducersDetailsPartiesAndNotesContentHeaderText
                    }
                  >
                    Notes
                  </p>
                </div>
                <ExpandMoreOutlinedIcon
                  className={Styles.CoProducersDetailsPAtiesAndNotesIcon}
                  onClick={() => HandleCahngeNotes()}
                />
              </div>
              {notesOpen === true ? (
                <div className={Styles.CoProducersDetailsPartiesContainer}>
                  <p className={Styles.CoProducersDetailsPartiesContainerText}>
                    Call With Robin
                  </p>
                  <div className={Styles.CoProducersDetailsPartiesContent}>
                    <p className={Styles.CoProducersDetailsPartiesContentTitle}>
                      Note
                    </p>
                    <p className={Styles.CoProducersDetailsPartiesContentText}>
                      Spoke with Robin
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>



      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal">
          <div className={Styles.CreateCoProducersMainContainer}>
            <div className="ModelPopupHeader sam">
                            <p className="ModelPopupHeaderText">
                            Add Co-Producer
                            </p>
                            <CloseOutlinedIcon
                              onClick={() => handleClose()}
                              className="ModelPopupHeaderIcon"
                            />
                          </div>
            <div className="ModelPopupbody">
            <div className={Styles.CreateCoProducersInputContainer}>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    First Name
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="firstname"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        firstname: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    Last Name
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="lastname"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        lastname: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>Email</p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="emailid"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        emailid: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>Phone</p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="mobilenumber"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        mobilenumber: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    Street Address
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="addtess"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        addtess: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>City</p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="city"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        city: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>State</p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="state"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        state: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>Zip Code</p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="zipcode"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        zipcode: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    Accredited?
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="accredited"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        accredited: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    Refferral Source
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="username"
                    // onChange={(e) => setCreateCoProducers({ ...createCoProducers,: e.target.value })}
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    Date Added
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="date_added"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        date_added: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    CoProducers Probability
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="CoProducers_probability"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        CoProducers_probability: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputCartSingleInput}>
                <p className={Styles.CreateCoProducersInputCartText}>
                  General Comments
                </p>
                <InputStyled
                  id="outlined-basic"
                  className={Styles.LoginPageInputContainerInput}
                  inputProps={{ maxLength: 200 }}
                  name="username"
                  onChange={(e) =>
                    setCreateCoProducers({
                      ...createCoProducers,
                      general_comments: e.target.value,
                    })
                  }
                />
                {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
              </div>
            </div>
            </div>
            <div className="ModelPopupfooter sam">
              <button
                className={Styles.CreateCoProducersCancelButton}
                onClick={() => handleClose()}
              >
                Cancel
              </button>
              <button
                className={Styles.CreateCoProducersSubmitButton}
                onClick={() => addNewCoProducers()}
              >
                Submit
              </button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openEdit}
        onClose={handleCloseEdit}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal">
          <div className={Styles.CreateCoProducersMainContainer}>
            <div className="ModelPopupHeader sam">
                            <p className="ModelPopupHeaderText">
                            Edit Co-Producer
                            </p>
                            <CloseOutlinedIcon
                              onClick={() => handleCloseEdit()}
                              className="ModelPopupHeaderIcon"
                            />
                          </div>
            <div className="ModelPopupbody">
            <div className={Styles.CreateCoProducersInputContainer}>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    First Name
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="firstname"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        firstname: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    Last Name
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="lastname"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        lastname: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>Email</p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="emailid"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        emailid: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>Phone</p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="mobilenumber"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        mobilenumber: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    Street Address
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="addtess"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        addtess: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>City</p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="city"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        city: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>State</p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="state"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        state: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>Zip Code</p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="zipcode"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        zipcode: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    Accredited?
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="accredited"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        accredited: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    Refferral Source
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="username"
                    // onChange={(e) => setCreateCoProducers({ ...createCoProducers,: e.target.value })}
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputContent}>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    Date Added
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="date_added"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        date_added: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
                <div className={Styles.CreateCoProducersInputCart}>
                  <p className={Styles.CreateCoProducersInputCartText}>
                    CoProducers Probability
                  </p>

                  <InputStyled
                    id="outlined-basic"
                    className={Styles.LoginPageInputContainerInput}
                    inputProps={{ maxLength: 20 }}
                    name="CoProducers_probability"
                    onChange={(e) =>
                      setCreateCoProducers({
                        ...createCoProducers,
                        CoProducers_probability: e.target.value,
                      })
                    }
                  />
                  {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
                </div>
              </div>
              <div className={Styles.CreateCoProducersInputCartSingleInput}>
                <p className={Styles.CreateCoProducersInputCartText}>
                  General Comments
                </p>
                <InputStyled
                  id="outlined-basic"
                  className={Styles.LoginPageInputContainerInput}
                  inputProps={{ maxLength: 200 }}
                  name="username"
                  onChange={(e) =>
                    setCreateCoProducers({
                      ...createCoProducers,
                      general_comments: e.target.value,
                    })
                  }
                />
                {/* {error?.username && (
              <span className={Styles.registerErrormsg}>{error?.username}</span>
            )} */}
              </div>
            </div>
            </div>
            <div className="ModelPopupfooter sam">
              <button
                className={Styles.CreateCoProducersCancelButton}
                onClick={() => handleClose()}
              >
                Cancel
              </button>
              <button
                className={Styles.CreateCoProducersSubmitButton}
                onClick={() => addNewCoProducers()}
              >
                Submit
              </button>
            </div>
          </div>
        </Box>
      </Modal>

    </div>
  );
};
export default CoProducersDetails;
